import { AnyAction } from 'redux';
import { ApplicationState } from 'app/types-store';
import { ActionDispatching } from 'app/types-shared';
import { AddQueryParam } from './action-types';

export const actionCreators = {
  addQueryParam: (queryParam: string, value: string): ActionDispatching<AnyAction, ApplicationState> =>
    async (dispatch, getState) => {
      dispatch(new AddQueryParam(queryParam, value));
    }
};
